import React, { useState } from 'react';

function ContratoPicker({ show, contratos = [], onSelect, onClose }) {
  const [search, setSearch] = useState('');

  if (!show) return null;

  const filtered = (contratos || [])
    .filter(c => {
      const term = search.trim().toLowerCase();
      if (!term) return true;
      return (
        (c.numContrato || '').toLowerCase().includes(term) ||
        (c.fornecedor?.nome || c.nomeFornecedor || '').toLowerCase().includes(term) ||
        (c.objeto || '').toLowerCase().includes(term)
      );
    })
    .sort((a, b) => (a.numContrato || '').localeCompare(b.numContrato || '', 'pt-BR'));

  function handleSelect(c) {
    onSelect(c);
    setSearch('');
  }

  function handleClose() {
    setSearch('');
    onClose();
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 1065,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        className="modal-content"
        style={{
          width: '90%',
          maxWidth: 720,
          height: 500,
          maxHeight: 500,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 6,
          overflow: 'hidden',
        }}
      >
        <div className="modal-header bg-primary text-white" style={{ padding: '0.35rem 1rem' }}>
          <h6 className="modal-title mb-0 small">
            <i className="bi bi-search me-2"></i>SELECIONAR contrato para aditivo
          </h6>
          <button type="button" className="btn-close btn-close-white" onClick={handleClose} />
        </div>

        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '1rem' }}>
          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">
              <i className="bi bi-search me-1"></i>BUSCAR
            </label>
            <input
              autoFocus
              type="text"
              className="form-control form-control-sm"
              placeholder="Buscar por número do contrato, fornecedor ou objeto..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          <div className="border rounded" style={{ overflowY: 'auto', flex: 1 }}>
            <table className="table table-hover table-sm mb-0">
              <thead className="table-light">
                <tr>
                  <th className="small">Nº</th>
                  <th className="small">Fornecedor</th>
                  <th className="small">Objeto</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(c => (
                  <tr key={c.id} style={{ cursor: 'pointer' }} onClick={() => handleSelect(c)}>
                    <td className="small text-nowrap">{c.numContrato}</td>
                    <td className="small">{c.fornecedor?.nome || c.nomeFornecedor || ''}</td>
                    <td className="small text-truncate" style={{ maxWidth: 340 }}>{c.objeto}</td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan={3} className="text-center text-muted small py-3">
                      <i className="bi bi-inbox me-2"></i>Nenhum contrato encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="modal-footer" style={{ padding: '0.4rem 1rem' }}>
          <span className="text-muted small me-auto">
            {filtered.length} registro{filtered.length !== 1 ? 's' : ''} encontrado{filtered.length !== 1 ? 's' : ''}
          </span>
          <button type="button" className="btn btn-secondary btn-sm" onClick={handleClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContratoPicker;
